import { combineReducers } from 'redux';

import list from './list';
import details from './details';
import members from './details/members';
import nonMembers from './details/nonMembers';

export default combineReducers({
  list,
  details,
  members,
  nonMembers,
});
